<template>
  <v-container v-if="products.length > 0" fluid>
    <v-row v-masonry class="row-prods">
      <ProductItem
        v-for="product in products"
        :key="product.id"
        :product="product"
        :isReloadPageForRelatedProducts="isReloadPageForRelatedProducts"
        @redrawVueMasonry="$redrawVueMasonry(product.id)"
      />
    </v-row>
  </v-container>
</template>

<script>
import ProductItem from "../components/ProductItem";

export default {
  name: "ProductMasonry",
  props: {
    products: {
      type: Array,
      default: () => {
        return {};
      },
    },
    isReloadPageForRelatedProducts: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {
    ProductItem,
  },
};
</script>


<style scoped>
@media only screen and (max-width: 331px) {
  .row-prods {
    margin: 0 11% 0% 11%;
  }
}
@media only screen and (min-width: 331px) and (max-width: 381px) {
  .row-prods {
    margin: 0 13% 0% 13%;
  }
}
@media only screen and (min-width: 381px) and (max-width: 541px) {
  .row-prods {
    margin: 0 14% 0% 14%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductMasonry.vue